var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from './button-back-styles.scss';
import React from 'react';
import classNames from 'classnames';
const ButtonBack = (_a) => {
    var { color, leftIcon, leftIconClass, btnChildClass, onClick, testId, btnWrapClass } = _a, props = __rest(_a, ["color", "leftIcon", "leftIconClass", "btnChildClass", "onClick", "testId", "btnWrapClass"]);
    const handleOnClick = () => {
        if (!props.disabled && onClick)
            onClick();
    };
    return (React.createElement("div", { className: classNames(Styles.btnWrap, btnWrapClass) },
        React.createElement("div", { onClick: handleOnClick, className: classNames(Styles.leftIconWrap, leftIconClass) }, leftIcon),
        React.createElement("button", Object.assign({ type: 'button' }, props, { onClick: handleOnClick, "data-testid": testId }), props.children)));
};
export default ButtonBack;
